<template>
  <g>
    <g clip-path="url(#clip0_15_65)">
      <path
        d="M15 9.00024H9C8.45 9.00024 8 9.45024 8 10.0002V22.0002C8 22.5502 8.45 23.0002 9 23.0002H15C15.55 23.0002 16 22.5502 16 22.0002V10.0002C16 9.45024 15.55 9.00024 15 9.00024ZM12 15.0002C10.9 15.0002 10 14.1002 10 13.0002C10 11.9002 10.9 11.0002 12 11.0002C13.1 11.0002 14 11.9002 14 13.0002C14 14.1002 13.1 15.0002 12 15.0002ZM7.82 6.82024C8.17 7.17024 8.72 7.20024 9.12 6.92024C9.93 6.34024 10.93 6.00024 12 6.00024C13.07 6.00024 14.07 6.34024 14.88 6.91024C15.28 7.19024 15.83 7.17024 16.18 6.82024C16.61 6.39024 16.57 5.68024 16.09 5.32024C14.94 4.49024 13.53 4.00024 12 4.00024C10.47 4.00024 9.06 4.49024 7.91 5.32024C7.42 5.67024 7.39 6.39024 7.82 6.82024ZM12 0.000244141C9.36 0.000244141 6.94 0.930244 5.05 2.47024C4.59 2.85024 4.55 3.54024 4.97 3.96024C5.33 4.32024 5.9 4.35024 6.29 4.03024C7.84 2.77024 9.83 2.00024 12 2.00024C14.17 2.00024 16.16 2.77024 17.7 4.04024C18.09 4.36024 18.66 4.33024 19.02 3.97024C19.44 3.55024 19.4 2.86024 18.94 2.48024C17.06 0.930244 14.64 0.000244141 12 0.000244141Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_65">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000244141)"
        />
      </clipPath>
    </defs>
  </g>
</template>
